import { useLocalization } from '@/shared/i18n'
import { Chip, Stack } from '@/shared/ui'

import type { AnswerProps } from './types'

const CHOICES = [true, false]

export function YesNo({ value, onChange }: AnswerProps) {
  const { t } = useLocalization()

  return (
    <Stack direction="row" gap="sm" wrap className="ask__options">
      {CHOICES.map((choice) => (
        <Chip
          key={String(choice)}
          selected={value === choice}
          onClick={() => onChange(value === choice ? undefined : choice)}
        >
          {choice ? t('survey.yes') : t('survey.no')}
        </Chip>
      ))}
    </Stack>
  )
}
